import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import {
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../store/Api/common";
import SupportTicketUi from "./SupportTicketUi";
import {
  useEditSupportTicketMutation,
  useGetSupportTicketQuery,
} from "../../store/Api/supportTicket";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function SupportTicket() {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const [filtersId, setFiltersId] = useState({
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    stateId: "",
    cityId: "",
  });
  const [selectData, setSelectData] = useState({
    rrb: [],
    city: [],
    states: [],
  });
  const [supportTicketViewData, setSupportTicketViewData] = useState({});
  const [supportTicketView, setSupportTicketView] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [updateData, setUpDateData] = useState("");
  const [updateSupportTicket] = useEditSupportTicketMutation();
  const { data, isFetching, isLoading, refetch } = useGetSupportTicketQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
    rrb_id: tableQaury.rrbId,
  });
  const { data: rrb } = useGetRrbQuery({});
  // const { data: states, refetch: refetchStates } = useGetStatesQuery(
  //   { rrbId: filtersId?.rrbId },
  //   {
  //     skip: !filtersId?.rrbId,
  //   }
  // );
  // const { data: city, refetch: refetchcity } = useGetCityQuery(
  //   { rrbId: filtersId?.rrbId, stateId: filtersId?.stateId },
  //   {
  //     skip: !filtersId?.rrbId || !filtersId?.stateId,
  //   }
  // );
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
      // states: states?.data?.data,
      // city: city?.data?.data,
    });
  }, [rrb]);
  // useEffect(() => {
  //   if (filtersId?.rrbId && filtersId?.stateId) {
  //     refetchcity();
  //   }
  // }, [filtersId]);
  useEffect(() => {
    if (tableQaury?.rrbId) {
      refetch();
    }
  }, [tableQaury]);

  useEffect(()=>{
    if(filtersId?.rrbId){
      setTableQaury({
        ...tableQaury,
        rrbId: filtersId?.rrbId,
        page: 1,
      });
    }
  },[filtersId]);
  //   const deleteFn = async () => {
  //     try {
  //       const response = await deleteAuditQuestion({ id: deleteId });
  //       if (response?.data?.success) {
  //         // Call refetch to refresh the user list
  //         refetch();
  //       }
  //     } catch (error) {
  //       console.log(error, "verify otp error");
  //     }
  //   };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const handleCloseViewModal = () => {
    setSupportTicketView(false);
  };
  const handleCloseModal = () => {
    setShowForm(false);
  };
  const handleSubmit = async (values, { resetForm }) => {
    const formData = {
      ...updateData,
      ...values,
    };

    try {
      const response = await updateSupportTicket({
        id: updateData?.id,
        formData,
      });
      if (response?.data?.success) {
        setUpDateData("");
        setShowForm(false);
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const dataT = [
    {
      id: 1,
      rrb: "Ahemdabad",
      auditorname: "XYZ ABC",
      qaury:
        "i want to da data dformr i want to da data dformr i want to da data dformr i want to da data dformr i want to da data dformr",
      status: "open",
      answer: "-",
    },
  ];
  const truncateText = (text, wordLimit) => {
    const words = text?.split(" ") || [];
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };
  const columns = [
    ...(decodedToken?.role === 3 || decodedToken?.role === 4
      ? [{ title: "RRB", dataKey: "rrb", isObject: true, objectKey: "name" }]
      : []),

    {
      title: "Auditor", // Single column for full name
      render: (_, row) =>
        `${row.user?.firstname || ""} ${row.user?.lastname || ""}`.trim() ||
        "N/A",
    },
    {
      title: "Phone Number", // Single column for full name
      render: (_, row) => `${row.user?.phone_number}`,
    },
    // { title: "Query", dataKey: "query" },
    // { title: "Reason",   render: (_, row) =>
    //     `${row.reason || "-"} `
    // },
    {
      title: "Query",
      render: (_, row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          {truncateText(row.query, 20)}
        </div>
      ),
    },
    {
      title: "Comment",
      render: (_, row) => (
        <div
          style={{
            maxWidth: "200px",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          }}
        >
          {truncateText(row.reason || "-", 20)}
        </div>
      ),
    },
    {
      title: "Status",
      dataKey: "status",
      render: (status) => {
        const getBadgeColor = (status) => {
          switch (status) {
            case "resolved":
              return "bg-success text-white"; // Green badge for completed
            case "rejected":
              return "bg-danger text-white"; // Yellow badge for in progress
            default:
              return "bg-secondary text-white"; // Default gray badge for other statuses
          }
        };

        return (
     
        
          <div className="d-flex justify-content-center ">
          <span className={`badge ${getBadgeColor(status)}`}>
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
         
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          <button
            className="border-0 bg-transparent"
            onClick={() => {
              setSupportTicketViewData(row);
              setSupportTicketView(true);
            }}
          >
            <i class="fas fa-eye text-primary"></i>
          </button>
          {row.status == "open" ? (
            <>
              <button
                className="border-0 bg-transparent"
                type="button"
                onClick={() => {
                  setUpDateData({ ...row, status: "resolved" });
                  setShowForm(true);
                }}
              >
                <i class="fas fa-check text-success"></i>
              </button>
              <button
                className="border-0 bg-transparent"
                type="button"
                onClick={() => {
                  setUpDateData({ ...row, status: "rejected" });
                  setShowForm(true);
                }}
              >
                <i class="fas fa-window-close text-danger"></i>
              </button>
            </>
          ) : null}
        </div>
      ),
    },
  ];
  const applyFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: filtersId?.rrbId,
      stateId: filtersId?.stateId,
      cityId: filtersId?.cityId,
      page: 1,
    });
  };

  const removeFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      // stateId: "",
      // cityId: "",
    });
    setFiltersId({
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      // stateId: "",
      // cityId: "",
    });
    setSelectData({
      rrb: rrb?.data?.data,
      // states: decodedToken?.role == 1 ? states?.data : [],
      // city: [],
    });
  };

  return (
    <Layout>
      <SupportTicketUi
        columns={columns}
        data={data?.data?.data || []}
        // data={dataT}
        totalRecords={data?.data?.totalItems}
        onUpdate={""}
        loading={isLoading}
        tableQaury={tableQaury}
        deleteAdminFn={""}
        onPageChange={handlePageChange}
        setTableQaury={setTableQaury}
        selectData={selectData}
        setFiltersId={setFiltersId}
        // refetchStates={refetchStates}
        // refetchcity={refetchcity}
        setSelectData={setSelectData}
        filtersId={filtersId}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        supportTicketView={supportTicketView}
        handleCloseViewModal={handleCloseViewModal}
        supportTicketViewData={supportTicketViewData}
        handleCloseModal={handleCloseModal}
        showForm={showForm}
        updateData={updateData}
        handleSubmit={handleSubmit}
        toast={toast}
      />
    </Layout>
  );
}

export default SupportTicket;
